import script from "./TopicVideos.vue?vue&type=script&setup=true&lang=js"
export * from "./TopicVideos.vue?vue&type=script&setup=true&lang=js"

import "./TopicVideos.vue?vue&type=style&index=0&id=653f10f0&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-653f10f0"]])

export default __exports__